import { createClient } from '@supabase/supabase-js';

// Client Supabase avec la clé service_role — bypasse RLS.
// Utilisé uniquement pour les stats globales de la page Notifications
// (COUNT sur profiles / push_tokens), car la policy RLS par défaut sur
// ces tables limite la lecture à la ligne de l'utilisateur courant.
//
// SÉCURITÉ : cette clé est bundlée dans le JS livré sur admin.onpitch.fr.
// Le back-office est protégé par login admin_users, mais le bundle JS
// reste accessible à quiconque connaît l'URL. À terme, migrer vers une
// RPC Supabase SECURITY DEFINER pour éviter d'exposer la service key.
const url = process.env.REACT_APP_SUPABASE_URL!;
const serviceKey = process.env.REACT_APP_SUPABASE_SERVICE_KEY!;

export const supabaseService = createClient(url, serviceKey, {
  auth: { persistSession: false, autoRefreshToken: false },
});
